import Button, { ButtonVariants } from '@/components/atoms/Button/Button';
import { FormTextareaProps } from '@/components/molecules/FormTextarea/FormTextarea';
import { useState } from 'react';
import { Info } from 'react-feather';

const CHARACTER_LIMIT = 1000;

interface CommentEditorProps
  extends Pick<FormTextareaProps, 'value' | 'onChange' | 'placeholder'> {
  onSubmit: (val: string) => void;
  onCancel?: () => void;
}

export const CommentEditor = ({
  onSubmit,
  value: initialValue,
  onChange,
  placeholder = 'Write your comment here...',
  onCancel,
}: CommentEditorProps) => {
  const [value, setValue] = useState(initialValue);

  const overCharacterLimit = value.length > CHARACTER_LIMIT;
  const formValid = value.length > 0 && !overCharacterLimit;

  const handleInputChange = (val: string) => {
    setValue(val);
    onChange(val);
  };

  const handleSubmit = () => {
    if (overCharacterLimit) {
      return;
    }
    onSubmit(value);
  };

  return (
    <div className="flex flex-col gap-m">
      <div className="flex flex-col gap-s rounded-small border border-neutral-300 bg-white p-m">
        <textarea
          placeholder={placeholder}
          className="h-[66px] resize-y text-body2Light"
          value={value}
          onChange={(e) => handleInputChange(e.target.value)}
        />
        <div className="flex gap-s self-end">
          {onCancel && (
            <Button
              aria-label="Cancel comment"
              variant={ButtonVariants.Secondary}
              onClick={onCancel}
              size="small"
              data-testid="CommentEditor-cancel-button"
            >
              Cancel
            </Button>
          )}
          <Button
            aria-label="Post comment"
            variant={ButtonVariants.Tertiary}
            onClick={handleSubmit}
            size="small"
            disabled={!formValid}
            data-testid="CommentEditor-post-button"
          >
            Post
          </Button>
        </div>
      </div>
      {overCharacterLimit && (
        <div
          className="flex flex-row items-center gap-xs"
          data-testid="CommentEditor-error-message"
        >
          <Info size={12} stroke="#B00C0C" className="text-warning" />
          <p className="text-microMedium text-red-medium">
            Max number of characters is {CHARACTER_LIMIT}
          </p>
        </div>
      )}
    </div>
  );
};
